module.exports = __webpack_public_path__ + "img/EBSoftware2.0ca30cb3.png";